<!-- TODO: add disabled state -->
<div
  class="switch-container"
  [ngClass]="{ active: value, disabled: isDisabled }"
  (click)="handleClick()"
>
  <div class="switch-ball"></div>
</div>
